import { Backbone } from "extensions/backbone";

import { pazienHistory } from "common/components/pazienHistory";

import { TabsCollection } from "./tabsCollection";

export const TabsModel = Backbone.Model.extend({
    defaults: {
        name: "New layout",
        newTabButton: true,
        collapse: true,
        canCloseLastTab: false,
        stickyNav: true
    },
    
    initialize(props) {
        this.tabs = new TabsCollection(this.get("tabs"));
        
        this.listenTo(this.tabs, "add", (tabModel) => {
            this.trigger("tab:add", tabModel);
        });
        
        this.listenTo(this.tabs, "remove", (tabModel) => {
            this.trigger("tab:remove", tabModel);
        });
        
        // Serialize all changes in tabs back to this layout model
        this.listenTo(this.tabs, "add remove change", (tabModel) => {
            this.set("tabs", this.tabs.toJSON());
        });
    },
    
    addTab(tabData, activeTabID) {
        let model;
        
        // If tab doesn't have to be a new tab and tabs collection has any Tabs,
        // then just take the last tab and change its attrs
        if (tabData.newTab !== true && this.tabs.length) {
            model = this.tabs.get(activeTabID);
            model.set({
                ...tabData,
                fragment: pazienHistory.getCurrentFragment()
            });
        } else {
            model = this.tabs.add(tabData);
        }
        
        return model;
    },
    
    removeTab(tabID) {
        return this.tabs.remove(tabID);
    },
    
    activateTab(tabID) {
        this.tabs.each((tab) => tab.set("active", tab.id === tabID));
    }
});
